import { useQuery } from '@tanstack/react-query';

import {
  companyConfigurationService,
  IndividualDeductionReportHeadersResponse,
} from '@aslanpay/portal-common-lib';

const useFetchReportHeaderOptions = (companyId?: string) => {
  return useQuery<IndividualDeductionReportHeadersResponse, Error>(
    ['fetchReportHeaderOptions', companyId],
    () => companyConfigurationService.fetchReportHeaderOptions(companyId || ''),
    {
      enabled: !!companyId,
    }
  );
};

export default useFetchReportHeaderOptions;
